export default function Resources() {
  return (
    <div className="space-y-6">
      <div className="overline">Marketing resources</div>
      <div className="grid md:grid-cols-2 gap-4">
        <div className="border border-black/10 p-6">
          <div className="font-display font-semibold">Brand assets</div>
          <p className="text-sm text-zinc-600 mt-2">PRMU wordmark, product photography, and social kits. Placeholder — assets will be provisioned after partner approval.</p>
        </div>
        <div className="border border-black/10 p-6">
          <div className="font-display font-semibold">Copy library</div>
          <p className="text-sm text-zinc-600 mt-2">Approved short-form copy for social and newsletter. Never use medical or performance claims.</p>
        </div>
        <div className="border border-black/10 p-6">
          <div className="font-display font-semibold">Compliance checklist</div>
          <p className="text-sm text-zinc-600 mt-2">"For laboratory research only" disclosure required on all creative.</p>
        </div>
        <div className="border border-black/10 p-6">
          <div className="font-display font-semibold">Reporting cadence</div>
          <p className="text-sm text-zinc-600 mt-2">Commissions transition pending → approved on fulfillment. Payouts run Net-15.</p>
        </div>
      </div>
    </div>
  );
}
